import { Badge } from "@/components/ui/badge"
import { Calendar, Users, Loader2, CalendarCheck, Flag, Ban, Globe } from "lucide-react"

type TagLabel = {
  id: number
  label: string
  color: string
  darkColor?: string
  icon: React.ReactNode
}

// Definición de estados con soporte dark
const statuses: Record<number, TagLabel> = {
  1: {
    id: 1,
    label: "Programado",
    color: "bg-gray-200 ",
    darkColor: "bg-gray-700 dark:text-gray-100",
    icon: <Calendar className="w-4 h-4" />,
  },
  2: {
    id: 2,
    label: "Inscripciones",
    color: "bg-yellow-200 text-yellow-800",
    darkColor: "bg-yellow-800 dark:text-yellow-800",
    icon: <Users className="w-4 h-4" />,
  },
  3: {
    id: 3,
    label: "Iniciado",
    color: "bg-blue-200 text-blue-800",
    darkColor: "bg-blue-800 dark:text-blue-800",
    icon: <Loader2 className="w-4 h-4 animate-spin" />,
  },
  4: {
    id: 4,
    label: "Proceso",
    color: "bg-blue-200",
    darkColor: "bg-blue-800 dark:text-blue-800",
    icon: <Loader2 className="w-4 h-4 animate-spin" />,
  },
  5: {
    id: 5,
    label: "Terminado",
    color: "bg-cyan-200 text-cyan-800",
    darkColor: "bg-cyan-800 dark:text-cyan-800",
    icon: <CalendarCheck className="w-4 h-4" />,
  },
  6: {
    id: 6,
    label: "Reportado",
    color: "bg-green-600 text-green-200",
    darkColor: "bg-green-800 dark:text-green-200",
    icon: <Flag className="w-4 h-4" />,
  },
}

interface TournamentStatusBadgeProps {
  statusId: number
  className?: string
  extraText?: string
  mini?: boolean
}

export const TournamentStatusBadge = ({
  statusId,
  className = "status-badge",
  extraText = "",
  mini = false,
}: TournamentStatusBadgeProps) => {
  const status = statuses[statusId]

  if (!status) return null

  if (mini) {
    return (
      <span className={className}>
        <Badge
          variant="outline"
          className={`inline-flex items-center gap-1 px-2 py-1 rounded-sm font-medium shadow-xs ${status.color} dark:${status.darkColor}`}
        >
          {status.icon}
        </Badge>
      </span>
    )
  }

  return (
    <span className={className}>
      <Badge
        variant="outline"
        className={`inline-flex items-center gap-1 px-2 py-1 rounded-2xl font-medium shadow-sm ${status.color} dark:${status.darkColor}`}
      >
        {extraText && (
          <span>
            <b>{extraText}</b>
          </span>
        )}
        {status.icon}
        <span>{status.label}</span>
      </Badge>
    </span>
  )
}

// Badge online/presencial con dark mode
const tournamentTypes: Map<boolean, TagLabel> = new Map([
  [
    false,
    {
      id: 1,
      label: "Torneo Online",
      color: "bg-blue-100 text-blue-800",
      darkColor: "bg-blue-800",
      icon: <Globe className="w-4 h-4" />,
    },
  ],
  [
    true,
    {
      id: 2,
      label: "Torneo Presencial",
      color: "bg-green-100",
      darkColor: "bg-green-100 text-green-800",
      icon: <Users className="w-4 h-4" />,
    },
  ],
])

interface TournamentPresentialBadgeProps {
  state: boolean
  className?: string
}

export const TournamentPresentialBadge = ({
  state,
  className = "",
}: TournamentPresentialBadgeProps) => {
  const status = tournamentTypes.get(state)
  if (!status || state) return null

  return (
    <div className={className}>
      <Badge
        variant="outline"
        className={`flex items-center gap-1 px-2 py-1 rounded-2xl font-medium shadow-sm ${status.color} dark:${status.darkColor}`}
      >
        {status.icon}
        <span>{status.label}</span>
      </Badge>
    </div>
  )
}
